module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Business-3d980ff3fab36b2aa9dc22ab16ed3703.png";